module.exports = __webpack_public_path__ + "static/img/img1.afa5035.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img1.jpg
// module id = Eaaq
// module chunks = 101